/*********************************************
 * USER
 *********************************************/
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_USER_TOKEN = 'SET_USER_TOKEN';


/*********************************************
 * INDICATORS
 *********************************************/
export const SET_ACTIVE_INDICATOR_ID = 'SET_ACTIVE_INDICATOR_ID';
export const SET_ACTIVE_INDICATOR_DATA = 'SET_ACTIVE_INDICATOR_DATA';
export const SET_ACTIVE_INDICATOR_OBSERVATION_GROUP_DATA = 'SET_ACTIVE_INDICATOR_OBSERVATION_GROUP_DATA';
export const SET_ACTIVE_INDICATOR_OBSERVATION_DATA = 'SET_ACTIVE_INDICATOR_OBSERVATION_DATA';
export const REMOVE_ACTIVE_INDICATOR_OBSERVATION_GROUP_DATA = 'REMOVE_ACTIVE_INDICATOR_OBSERVATION_GROUP_DATA';
export const REMOVE_ACTIVE_INDICATOR_OBSERVATION_DATA = 'REMOVE_ACTIVE_INDICATOR_OBSERVATION_DATA'


/*********************************************
 * SCENARIO
 *********************************************/
export const SET_SCENARIO_INDICATORS = 'SET_SCENARIO_INDICATORS';
export const SET_SCENARIO_ACTIVE_CHILD = 'SET_SCENARIO_ACTIVE_CHILD';
export const SET_SCENARIO_ACTIVE_ADULT = 'SET_SCENARIO_ACTIVE_ADULT';
export const SET_ACTIVE_SCENARIO = 'SET_ACTIVE_SCENARIO';
export const SET_ACTIVE_SCENARIO_DATA = 'SET_ACTIVE_SCENARIO_DATA';

/*********************************************
 * MISC
 *********************************************/
export const SET_CURRENT_BACKGROUND = 'SET_CURRENT_BACKGROUND';
export const SET_CURRENT_APP_SEGMENT = 'SET_CURRENT_APP_SEGMENT'
export const SET_APP_CONFIG = 'SET_APP_CONFIG';
